export default "__VITE_ASSET__D1ePaL31__"